import { DepotsOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: DepotsOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'stateRegion',
    {
      [OrderDirection.ASC]: ['STATE_REGION_ASC'],
      [OrderDirection.DESC]: ['STATE_REGION_DESC'],
    },
  ],
  [
    'cityArea',
    {
      [OrderDirection.ASC]: ['CITY_AREA_ASC'],
      [OrderDirection.DESC]: ['CITY_AREA_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder): DepotsOrderBy[] => {
  const orderByArray: DepotsOrderBy[] = [
    'STATE_REGION_ASC',
    'CITY_AREA_ASC',
    'PRIMARY_KEY_ASC',
  ];

  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];

  return [
    ...(orderBy ? (Array.isArray(orderBy) ? orderBy : [orderBy]) : []),
    'PRIMARY_KEY_ASC',
  ];
};
